import req from './base'


export const emailAuthentication = (token) => req.post('/rcs-member/member/validate-email',token)







